import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export type FieldHintVariant = 'info' | 'warn';
export type FieldHintAlign = 'start' | 'end';

@Component({
  selector: 'app-field-hint',
  templateUrl: './field-hint.component.html',
  styleUrl: './field-hint.component.scss',
  standalone: true,
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldHintComponent {
  @Input({ required: true }) text = '';
  @Input() variant: FieldHintVariant = 'info';
  @Input() hintLabel: string | null = null;
  @Input() align: FieldHintAlign = 'end';
  @Input() wide = false;

  get iconName(): string {
    return this.variant === 'warn' ? 'warning' : 'info';
  }

  get accessibleLabel(): string {
    return this.hintLabel ?? this.text;
  }

  closeHint(event: Event): void {
    (event.target as HTMLElement | null)?.blur();
  }
}
